<template>
  <v-footer app>
    <v-layout class="ma-0" v-if="backButton || nextButton">
      <v-flex xs6 class="pa-0">
        <v-list class="blue py-0" dark v-if="backButton">
          <v-list-tile ripple :to="{ name: backButton, params: { id: currentDataset.meta.id } }">
            <v-icon dark class="mr-5 hidden-xs-only">arrow_back</v-icon>
            <v-list-tile-content>
              <v-list-tile-sub-title>Zurück</v-list-tile-sub-title>
              <v-list-tile-title>{{ backButton }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-list class="blue darken--2 py-0" dark v-else>
          <v-list-tile>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs6 class="pa-0">
        <v-list class="primary py-0" dark v-if="nextButton">
          <v-list-tile ripple :to="{ name: nextButton, params: { id: currentDataset.meta.id } }">
            <v-list-tile-content>
              <v-list-tile-sub-title class="text-xs-right">Weiter</v-list-tile-sub-title>
              <v-list-tile-title class="text-xs-right">{{ nextButton }}</v-list-tile-title>
            </v-list-tile-content>
            <v-icon dark class="ml-5 hidden-xs-only">arrow_forward</v-icon>
          </v-list-tile>
        </v-list>

        <v-list class="primary py-0" dark v-else>
          <v-list-tile>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  computed: {
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    backButton () {
      for (var i = this.steps.length - 1; i >= 0; i--) {
        if (this.steps[i] === this.$route.name && (i - 1) >= 0) return this.steps[i - 1]
      }
      return ''
    },
    nextButton () {
      for (var i = this.steps.length - 1; i >= 0; i--) {
        if (this.steps[i] === this.$route.name && (i + 1) <= (this.steps.length - 1)) return this.steps[i + 1]
      }
      return ''
    }
  },
  data () {
    return {
      steps: [
        'Erfassung',
        'Bewertung',
        'Aufwertung',
        'Anonymisierung'
      ]
    }
  },
  methods: {
    login (userId) {
      this.$store.dispatch('loginUser', userId).then(() => {
        this.$router.push('/dashboard')
      })
    }
  }
}
</script>

<style>
.login {
  background-color: #ccc
}
</style>



// WEBPACK FOOTER //
// src/components/FooterArrows.vue